<!-- Step: CONNECTING -->
<div>
  <div>
    <div class="flex justify-center mt-fdk-xxxl"><fdk-illustration name="sign-in" /></div>
    <h1 class="fdk-type-heading-2 text-fdk-primary text-center mt-fdk-m">
      Complete sign-in
    </h1>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
      Please finish signing in using the window that just opened.
    </p>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xs">
      Having trouble connecting? Our support team can help.
    </p>
  </div>
  <div class="flex justify-center mt-fdk-m">
    <fdk-button
      id="contact-support"
      [routerLink]="'/form/support'"
      [queryParams]="{
        brand_id: brandId,
        portal_id: portalId,
        endpoint_id: endpointId,
        org_connection_id: orgConnectionId,
        external_id: externalId,
        external_state: externalState,
      }"
      variant="secondary"
    >
      Contact Support
    </fdk-button>
  </div>
</div>
<!-- End Step: CONNECTING -->
